module.exports = __webpack_public_path__ + "static/img/1-1.8170f66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/1-1.png
// module id = Lokm
// module chunks = 0